module.exports = __webpack_public_path__ + "static/assets/e8b9e772b56ad2e3fa52aa9d47919880.png";